export default [
    {
        path: 'relatorio-viagem-data',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-viagem-data' */
            '@/views/transporte-paciente/relatorio-viagem-data/Index'
        ),
        redirect: 'relatorio-viagem-data/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-viagem-data-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-viagem-data' */
                    '@/views/transporte-paciente/relatorio-viagem-data/List.vue'
                ),
            },
        ],
    },
]
